import React from "react";
import "./App.css";
import Nav from "./mainpage/components/Nav";
import { BrowserRouter as Router, Route, } from "react-router-dom";
import Home from "./mainpage/Home";
import Works from "./mainpage/Works";
import Contact from "./mainpage/Contact";
import Profile from "./mainpage/Profile";
import ParticlesContainer from "./mainpage/components/ParticlesContainer";

class App extends React.Component {
  render() {
    return (
      <Router>
        <ParticlesContainer />
        <Nav />
        <div id="empty" />
        <Route exact path="/" component={Home} />
        <Route exact path="/Profile" component={Profile} />
        <Route path="/Works" component={Works} />
        <Route path="/Contact" component={Contact} />
      </Router>
    );
  }
}

export default App;
